/**
 * @author Matt Smith http://gun.net.au @ktingvoar
 */


import fragment from './shaker.glsl';

var ShakerFilter = function () {
    PIXI.AbstractFilter.call(this);

    this.passes = [this];

    this.uniforms = {
        dimensions: {type: '4fv', value: [0, 0, 0, 0]},
        blur: {type: '2fv', value: [0, 0]}
    };

    this.fragmentSrc = fragment;

};

ShakerFilter.prototype = Object.create(PIXI.AbstractFilter.prototype);
ShakerFilter.prototype.constructor = ShakerFilter;

Object.defineProperties(ShakerFilter.prototype, {
    blurX : {
        get: function() {
            return this.uniforms.blur.value[0];
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.blur.value[0] = value;
        }
    },

    blurY : {
        get: function() {
            return this.uniforms.blur.value[1];
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.blur.value[1] = value;
        }
    }

});

module.exports = ShakerFilter;


/** WEBPACK FOOTER **
 ** ./src/js/views/shaders/shaker.js
 **/